/** What chose a tracked leg: anything an LLM chose is AI; a person's pick is manual, or bet. */

import type { AnalysisConfig } from './analysisConfig.ts';

export const LEG_PROVENANCES = ['generation', 'chat', 'analyzer', 'manual', 'bet'] as const;

export type LegProvenance = (typeof LEG_PROVENANCES)[number];

export const LEG_PROVENANCE = {
  generation: 'generation',
  chat: 'chat',
  analyzer: 'analyzer',
  manual: 'manual',
  bet: 'bet',
} as const satisfies Record<LegProvenance, LegProvenance>;

/** The legs.origin value for a provenance: every LLM choice is 'ai'. */
export const ORIGIN_BY_PROVENANCE: Record<LegProvenance, 'ai' | 'manual' | 'bet'> = {
  generation: 'ai',
  chat: 'ai',
  analyzer: 'ai',
  manual: 'manual',
  bet: 'bet',
};

/** The per-leg fields a track request carries (POST /api/parlays/track). */
export interface LegProvenanceFields {
  provenance?: LegProvenance;
  /** A generated leg's prediction row id. */
  predictionId?: string;
  /** The factor toggles a chat or analyzer workflow fed its prompt. */
  factorsUsed?: AnalysisConfig | null;
}
